<template>
	<div>
		<v-layout row wrap>
			<v-flex xs12 class="pa-5" :class="theme.bg">
				<v-layout>
					<v-flex xs12 text-xs-center>
						<img src="@/assets/img/circle_logo_256.png" width="192px;">
						<p class="mt-3 mb-0 display-1 font-weight-thin" :class="theme.fontColor" :style="$vuetify.breakpoint.mdAndUp ? 'letter-spacing: 12px !important;' : 'letter-spacing: 4px !important;'">NIKOWORKS</p>
						<p style="font-weight: 300;">Softwares, aplicativos, design, jogos, vídeos e mais.</p>
					</v-flex>
				</v-layout>
			</v-flex>

			<v-flex xs12>
				<v-card flat :class="$vuetify.breakpoint.mdAndUp ? theme.alt + ' pa-5' : theme.alt + ' pa-3'">
					<v-btn absolute dark fab top right color="white" @click="changeTheme">
						<v-icon :class="theme.fontColorAlt">format_paint</v-icon>
					</v-btn>

					<p class="mb-0" style="font-size: 1.8em; font-weight: 400; letter-spacing: 4px;">PORTFOLIO</p>

					<portfolio-item></portfolio-item>
				</v-card>
			</v-flex>

			<v-flex xs12>
				<v-card flat :class="$vuetify.breakpoint.mdAndUp ? theme.bg + ' pa-5' : theme.bg + ' pa-3'">
					<p class="mb-0" style="font-size: 1.8em; font-weight: 400; letter-spacing: 4px;">SOBRE MIM</p>

					<v-layout row wrap justify-center v-if="$vuetify.breakpoint.mdAndUp">
						<v-flex xs4 sm4 offset-xs4 text-xs-right>
							<p class="mt-5 mb-0" :class="theme.fontColor" style="font-size: 1.8em; font-weight: 400; letter-spacing: 8px;">NICOLAS MELLO</p>
							<p style="font-weight: 300;">Engenheiro de software, autodidata, designer, amante de jogos e inspirado pela tecnologia.</p>
						</v-flex>

						<v-flex xs4 sm4 text-xs-center>
							<v-avatar size="192px"><img src="@/assets/img/niko.jpg"></v-avatar>
						</v-flex>

						<v-flex xs4 text-xs-center>
							<v-btn outline disabled :color="theme.btn">Blog</v-btn>
						</v-flex>
					</v-layout>

					<v-layout row wrap justify-center v-else class="mt-5">
						<v-flex xs12 text-xs-center>
							<v-avatar size="192px"><img src="@/assets/img/niko.jpg"></v-avatar>

							<p class="mt-5" :class="theme.fontColor" style="font-size: 1.8em; font-weight: 400; letter-spacing: 8px;">NICOLAS MELLO</p>
							<p style="font-weight: 300;">Engenheiro de software, autodidata, amante de jogos e inspirado pela tecnologia.</p>

							<v-btn outline disabled :color="theme.btn">Blog</v-btn>
						</v-flex>
					</v-layout>
				</v-card>
			</v-flex>

			<v-flex xs12>
				<v-card flat :class="$vuetify.breakpoint.mdAndUp ? theme.alt + ' pa-5' : theme.alt + ' pa-3'">
					<p class="mb-0" style="font-size: 1.8em; font-weight: 400; letter-spacing: 4px;">EXPERIÊNCIA</p>

					<experience-item></experience-item>
				</v-card>
			</v-flex>

			<v-flex xs12>
				<v-card flat :class="$vuetify.breakpoint.mdAndUp ? theme.bg + ' pa-5' : theme.bg + ' pa-3'">
					<p class="mb-0" style="font-size: 1.8em; font-weight: 400; letter-spacing: 4px;">METAS</p>

					<div class="mt-3 py-3">
						<venture-chip :hasIcon="true" vc_icon="timeline" vc_title="Machine Learning"></venture-chip>
						<venture-chip :hasIcon="true" vc_icon="cloud" vc_title="Cloud Computing"></venture-chip>
						<venture-chip :hasIcon="true" vc_icon="settings" vc_title="Microservices"></venture-chip>
						<venture-chip :hasIcon="true" vc_icon="developer_mode" vc_title="Arduino e IoT"></venture-chip>
					</div>
				</v-card>
			</v-flex>

			<v-flex xs12 text-xs-center>
				<v-card flat class="pa-3" :class="theme.alt">
					<p class="mb-0 caption font-weight-thin" style="letter-spacing: 2px !important;">NIKOWORKS - TODOS OS DIREITOS RESERVADOS</p>
					<!--<v-btn icon :color="theme.fontColor" @click="changeTheme()"><v-icon>build</v-icon></v-btn>-->
				</v-card>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import Portfolio from '@/components/Portfolio'
import Experience from '@/components/Experience'
import VentureChip from '@/components/VentureChip'

export default {
	components: {
		'portfolio-item':Portfolio,
		'experience-item':Experience,
		'venture-chip':VentureChip
	},
	data() {
		return {
			dark: {
				bg: 'grey darken-3',
				alt: 'grey darken-4',
				btn: 'white',
				chip: 'grey darken-4',
				fontColor: 'white--text',
				fontColorAlt: 'grey--text text--darken-4'
			},
			light: {
				bg: 'grey lighten-4',
				alt: 'grey lighten-3',
				btn: 'primary',
				chip: 'primary',
				fontColor: 'primary--text',
				fontColorAlt: 'primary--text'
			},
			theme: []
		}
	},
	mounted() {
		this.processTheme()
	},
	computed: {
	},
	methods: {
		changeTheme() {
			let theme = this.$store.getters.getTheme
			this.$store.dispatch('changeTheme', theme = !theme)
		},
		processTheme() {
			this.$store.getters.getTheme ? this.theme = this.dark : this.theme = this.light
		}
	},
	watch: {
		'$store.getters.getTheme' () {
			this.processTheme()
		}
	}
}
</script>
